// extracted by mini-css-extract-plugin
module.exports = {"broadcastNotification":"Broadcast_broadcastNotification__21ulV"};